import { render } from "./FormMember.vue?vue&type=template&id=260c2f45"
import script from "./FormMember.vue?vue&type=script&lang=js"
export * from "./FormMember.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__